export const normalizeGetAddressResponse = (
  data,
): { address: string; id: string }[] => {
  const cleanRepeatedAddress = (obj): { address: string; id: string }[] => {
    const uniqueAddresses = [];

    obj.forEach((elem) => {
      const address = uniqueAddresses.find((item) => {
        return item.address === elem.fullAddress;
      });
      if (!address) {
        const newAddress = {
          address: elem.fullAddress,
          id: elem.id,
        };

        uniqueAddresses.push(newAddress);
      }
    });
    return uniqueAddresses;
  };

  return cleanRepeatedAddress(data.addresses);
};
